import { render, staticRenderFns } from "./TablaDatos.vue?vue&type=template&id=421a2163&"
import script from "./TablaDatos.vue?vue&type=script&lang=js&"
export * from "./TablaDatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports